import React from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@s4l/ds'
import styles from './index.module.css'

const InvoiceInfo: React.FC = () => {
  const intl = useIntl()

  return (
    <div className={styles.invoiceNote}>
      <Typography variant="body" size="l" as="p">
        {intl.formatMessage({
          id: 'invoice.conditions',
        })}
      </Typography>
    </div>
  )
}

export default InvoiceInfo
